import React from 'react'

const TextInput = React.forwardRef((props, ref) => (
  <label className='form-input'>
    <span>
      {props.label}
      {props.mandatory && <b>*</b>}
    </span>
    <input {...props} ref={ref} />
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default TextInput
